<ng-container *ngIf="estado$ | async as estado">

  <div
    class="adminseaf-loading"
    *ngIf="estado.visible">

    <div class="adminseaf-loading-content">

      <!-- LOGO -->
      <div class="adminseaf-logo-wrapper">
        <img
          src="assets/images/logo/logo-login.png"
          alt="Admin SEAF"
          class="adminseaf-loading-logo"
        />
      </div>

      <!-- CÍRCULO DE CARGA -->
      <div class="adminseaf-loader">
        <div class="adminseaf-loader-ring"></div>

        <div class="adminseaf-loader-icon">
          🚍
        </div>
      </div>

      <!-- TÍTULO -->
      <div class="adminseaf-loading-title">
       {{ estado.titulo }}
      </div>

      <!-- MENSAJE DINÁMICO -->
      <div class="adminseaf-loading-text">
        {{ estado.mensaje }}<span class="loading-dots"></span>
      </div>

      <!-- PUNTOS -->
      <div class="adminseaf-progress-dots">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>

    <!-- ESTADOS DINÁMICOS -->
    <div class="adminseaf-loading-status">
    
      <div class="status-item" *ngFor="let paso of estado.pasos">
    
        <!-- Mostrar únicamente si el paso está habilitado -->
        <ng-container *ngIf="paso.visible">
    
          <div class="status-icon" [ngClass]="paso.estado">
    
            <!-- En proceso -->
            <span *ngIf="paso.estado === 'cargando'" class="spinner-border spinner-border-sm">
            </span>
    
            <!-- Completado -->
            <span *ngIf="paso.estado === 'completado'">
              ✓
            </span>
    
            <!-- Pendiente -->
            <span *ngIf="paso.estado === 'pendiente'">
              {{ paso.icono }}
            </span>
    
            <!-- Error -->
            <span *ngIf="paso.estado === 'error'">
              !
            </span>
    
          </div>
    
          <span>{{ paso.nombre }}</span>
    
        </ng-container>
    
      </div>
    
    </div>

    </div>
  </div>

</ng-container>